var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-container',{staticClass:"bv-example-row",attrs:{"fluid":"true"}},[_c('p',[_vm._v(" Downloading file: "+_vm._s(_vm.filename))]),_c('b-progress',{staticClass:"mb-3",attrs:{"value":_vm.value,"max":_vm.max}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }